import { api, withFallback } from "./api";
import { MEDIA, BEFORE_AFTER } from "../data/media";

export const mediaService = {
  list: () => withFallback(() => api.get("/media"), MEDIA),
  featured: () =>
    withFallback(
      () => api.get("/media/featured"),
      MEDIA.filter((m) => m.featured)
    ),
  beforeAfter: () =>
    withFallback(() => api.get("/media/before-after"), BEFORE_AFTER),
};
